import React from 'react'
import {observable, action} from 'mobx'
import {notification} from 'antd'

export class Debug {
  @observable backtest
  @observable results
  @observable debugResults
  @observable loading

  constructor(rootStore) {
    this.rootStore = rootStore

    this.backtest = {
      algo: {}
    }
    this.results = {
      columns: [],
      data: [],
      index: []
    }
    this.debugResults = []
    this.loading = false
  }

  getLabel(bool) {
    const text = bool ? 'yes' : 'no'
    const type = bool ? 'success' : 'danger'
    return (
      <span className={`label label-table label-${type}`}>{text}</span>
    )
  }

  @action async getData(id) {
    this.loading = true
    try {
      const {backtest, results, debug_results} = await this.rootStore.api.request(`sys/backtests/${id}/debug`, 'get')
      this.backtest = backtest
      this.results = results
      let debugResults = []
      for (let date in debug_results) {
        const cover = debug_results[date].cover_trades ? !!debug_results[date].cover_trades.length : false
        debugResults.push({
          key: date,
          date: date,
          condition: this.getLabel(debug_results[date].result),
          cover: this.getLabel(cover),
          data: debug_results[date]
        })
      }
      this.debugResults = debugResults
    } catch (e) {
      notification['error']({
        message: 'Failed to get debug data',
        description: e.message || 'Unknown error'
      })
    } finally {
      this.loading = false
    }
  }
}
